import { IIndexable } from "../../types/common";

const noindexNofollow: string = "noindex, nofollow";
const noindexFollow: string = "noindex, follow";

export const pathToRobots: IIndexable = {
  "what-is-mev": noindexNofollow,
  "what-is-ethereum-and-ethereum-2-0": noindexNofollow,
  "what-is-cryptocurrency": noindexNofollow,
  "what-is-a-validator": noindexNofollow,
  "what-are-dapps": noindexNofollow,
  "staking-academy-catering-from-newbies-to-degens": noindexNofollow,
  "polygon-use-cases": noindexNofollow,
  "matic-bridges": noindexNofollow,
  "how-to-stake-eth": noindexNofollow,
  "how-to-stake-bnb": noindexNofollow,
  "how-to-add-matic-to-metamask": noindexNofollow,
  "ethereum-virtual-machine": noindexNofollow,
  "liquid-staking-101": noindexFollow,
  "benefits-of-staking-bnb": noindexNofollow,
};
